import React, { useState } from "react";
import { Grid, MenuItem, TextField } from "@mui/material";
import moment from "moment/moment";

import { addPermisoAsync } from "../../../../api/Nomina";
import { getToken } from "../../../../api/Account";
import { useAviso } from "../../../../components/base";
import {
  CampoFecha,
  DialogoFormulario,
  fechaCambiada,
  useEnvio,
  useEscritura,
} from "../comunes";

const HORAS = [1, 2, 3, 4, 5, 6, 7, 8];

const AddPermiso = ({ id, setShowModal, reload, setReload }) => {
  const [fecha, setFecha] = useState(new Date());

  const [isJustificado, setIsJustificado] = useState(1);
  const [horasSolicitadas, setHorasSolicitadas] = useState(1);
  const [motivo, setMotivo] = useState("");
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Única regla de siempre: el motivo no puede ir vacío.
  const errorMotivo = motivo.length === 0 ? "Ingrese un motivo" : "";

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (errorMotivo) return;

      const data = {
        employeeId: parseInt(id),
        motivo,
        fecha: moment(fecha).format("YYYY-MM-DD"),
        isJustificado,
        horasAusencia: horasSolicitadas,
      };

      const ok = await escribir(
        () => addPermisoAsync(token, data),
        "No se pudo agregar la ausencia"
      );
      if (!ok) return;
      aviso.exito("Ausencia agregada");
      setReload(!reload);
      setShowModal(false);
    });

  return (
    <DialogoFormulario
      titulo="Agregar ausencia"
      onCerrar={() => setShowModal(false)}
      hayCambios={
        motivo !== "" || isJustificado !== 1 || horasSolicitadas !== 1 || fechaCambiada(fecha)
      }
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Agregar ausencia"
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Tipo de ausencia"
            value={isJustificado}
            onChange={(e) => setIsJustificado(e.target.value)}
            helperText=" "
            disabled={guardando}
          >
            <MenuItem value={1}>JUSTIFICADO</MenuItem>
            <MenuItem value={2}>INJUSTIFICADO</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <CampoFecha
            label="Fecha"
            value={fecha}
            onChange={(newValue) => setFecha(newValue)}
            disabled={guardando}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Horas de ausencia"
            value={horasSolicitadas}
            onChange={(e) => setHorasSolicitadas(e.target.value)}
            helperText=" "
            disabled={guardando}
          >
            {HORAS.map((hora) => (
              <MenuItem key={hora} value={hora}>
                {hora}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            fullWidth
            label="Motivo"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value.toLocaleUpperCase())}
            error={intentado && Boolean(errorMotivo)}
            helperText={intentado && errorMotivo ? errorMotivo : " "}
            disabled={guardando}
            inputProps={{ autoComplete: "off" }}
          />
        </Grid>
      </Grid>
    </DialogoFormulario>
  );
};

export default AddPermiso;
